









































































































































import "./project-board.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { Container, Draggable, Utils } from "vue-smooth-dnd";
import { applyDrag, generateItems } from "./helpers";
import CardDetail from "./card-detail.vue";
import AttachmentEditor from "../goals/attachment-editor.vue";
import DueDateSetup from "./due-date-setup.vue";
import CardMembers from "./card-members.vue";
import Checklist from "./checklist.vue";
import ListCard from "./list-card.vue";
import VideoPlayer from "../video-player/video-player.vue";
import ResizableTextarea from "../common/ResizableTextarea.js";
import Modal from "../common/confirm.js";

let board = {
  children: [],
};

export default Vue.extend({
  name: "project-board",
  components: { Container, Draggable, CardDetail, AttachmentEditor, DueDateSetup, CardMembers, Checklist, ListCard, VideoPlayer, ResizableTextarea },
  props: {
    id: String,
  },
  data() {
    return {
      isLoading: false,
      addList: false,
      newListTitle: null,
      board,
      upperDropPlaceholderOptions: {
        className: "cards-drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      showCardDetail: false,
      showDueDateEditor: false,
      showCardMembers: false,
      showChecklist: false,
      showAttachmentEditor: false,
      showCardEditor: false,
      edittingCard: null,
      edittingCardColumn: null,
      edittingCardTitle: null,
      edittingCardAttachments: [],
      cardEditorStyles: {},
      attachmentEditorStyles: {},
      disableAttachmentEdit: false,
      showVideoPlayer: false,
      videoUrl: "",
      isScrolling: false,
      scrollTimeout: null,
    };
  },
  computed: {
    boardModel(): any {
      return this.board.children.map((column) => {
        return {
          id: column.id,
          name: column.name,
          children: column.children.map((card) => {
            return {
              id: card.id,
              title: card.title,
              description: card.description,
              dueDateSetting: card.dueDateSetting,
              selectedMemberIds: card.selectedMemberIds ? card.selectedMemberIds : [],
              checklists: card.checklists ? card.checklists : [],
              attachments: card.attachments,
            };
          }),
        };
      });
    },
    ...mapState("project", ["currentProject"]),
    ...mapGetters("project", ["canEditCurrentProject"]),
  },
  mounted() {
    this.$Notice.config({
      top: 50,
      duration: 2,
    });

    this.loadBoard();

    let context = this;
    abp.event.on("abp.notifications.received", this.handleNotificationReceived);
  },
  beforeDestroy() {
    console.log("leave page");
    abp.event.off("abp.notifications.received", this.handleNotificationReceived);
  },
  watch: {
    boardModel: {
      handler: function () {
        if (this.isLoading === true) {
          return;
        }

        let currentProject = (this as any).currentProject;
        let projectBoard = {
          boardData: JSON.stringify(this.boardModel),
          boardDataVersion: currentProject.boardDataVersion,
          id: currentProject.id,
        };

        if (projectBoard.boardData != currentProject.boardData) {
          this.$store
            .dispatch("project/updateBoardData", { data: projectBoard })
            .then((response) => {
              this.$Notice.success({
                title: "Saved",
              });
            })
            .catch((error) => {
              if (error.response.status === 403) {
                this.loadBoardData();
              }
            });
        }
      },
      deep: true,
    },
    currentProject() {
      let context = this as any;
      context.loadBoardData();
    },
  },
  methods: {
    loadBoard() {
      let context = this;
      this.$store.dispatch("project/get", { id: this.id }).then((response) => {});
    },
    loadBoardData() {
      let context = this as any;
      let boardData = context.currentProject.boardData;
      let columns = [];
      if (boardData !== null && boardData !== "") {
        columns = JSON.parse(boardData);
      }

      this.isLoading = true;
      this.board.children = columns.map((column) => {
        return {
          id: column.id,
          name: column.name,
          addCard: false,
          newCardTitle: "",
          children: column.children,
        };
      });

      setTimeout(function () {
        context.isLoading = false;
      }, 100);
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentProject.boardDataVersion) {
        this.loadBoard();
      }
    },
    handleNewList() {
      this.addList = true;
      this.newListTitle = "";
    },
    handleSaveNewList() {
      this.board.children.push({
        id: this.uuid(),
        name: this.newListTitle,
        addCard: false,
        newCardTitle: "",
        children: [],
      });
      this.addList = false;
    },
    handleMenuItemClick(name, list) {
      switch (name) {
        case "delete":
          Modal.confirm({
            title: "Delete list?",
            content: "<p>When you delete a list it will also delete all the cards in the list. After the list and cards are deleted they cannot be restored.</p>",
            okText: "Delete this list",
            cancelText: "Never mind",
            onOk: () => {
              this.handleDeleteList(list);
            },
          });
          break;
      }
    },
    handleDeleteList(list) {
      for (var i = 0; i < this.board.children.length; i++) {
        if (this.board.children[i] === list) {
          this.board.children.splice(i, 1);
        }
      }
    },
    handleNewCard(list) {
      list.addCard = true;
      list.newCardTitle = "";
    },
    handleSaveNewCard(list) {
      list.children.push({
        id: this.uuid(),
        title: list.newCardTitle,
        dueDateSetting: {},
        selectedMemberIds: [],
        checklists: [],
        attachments: [],
      });

      list.addCard = false;
    },
    handleCardActionClick(card, column, e) {
      if (!card.attachments) {
        card.attachments = [];
      }
      this.edittingCard = card;
      this.edittingCardColumn = column;
      this.edittingCardTitle = card.title;
      this.edittingCardAttachments = card.attachments.map((attachment) => Object.assign({}, attachment));
      this.getCardEditorPosition(e.target.parentElement);
      this.showCardEditor = true;
    },
    handleSaveCard() {
      if (this.edittingCardTitle && this.edittingCardTitle != "") {
        this.edittingCard.title = this.edittingCardTitle;
      }

      this.showCardEditor = false;
    },
    handleSaveAttachment() {
      if (JSON.stringify(this.edittingCard.attachments) != JSON.stringify(this.edittingCardAttachments)) {
        this.edittingCard.attachments = JSON.parse(JSON.stringify(this.edittingCardAttachments));
      }
      this.showAttachmentEditor = false;
      this.showCardEditor = false;
    },
    handleDeleteCard() {
      Modal.confirm({
        title: "Delete card?",
        content: "<p>When you delete a card it will also delete all associated attachments and checklists. After the card is deleted it cannot be restored.</p>",
        okText: "Delete this card",
        cancelText: "Never mind",
        onOk: () => {
          for (var i = 0; i < this.edittingCardColumn.children.length; i++) {
            if (this.edittingCardColumn.children[i] === this.edittingCard) {
              this.edittingCardColumn.children.splice(i, 1);
            }
          }
          this.showCardEditor = false;
          this.showCardDetail = false;
        },
      });
    },
    handleCopyCard() {
      for (var i = 0; i < this.edittingCardColumn.children.length; i++) {
        if (this.edittingCardColumn.children[i] === this.edittingCard) {
          let newCard = Object.assign({}, this.edittingCard);
          newCard = Object.assign(newCard, { id: this.uuid() });
          this.edittingCardColumn.children.splice(i, 0, newCard);
          break;
        }
      }
      this.showCardEditor = false;
      this.showCardDetail = false;
    },
    handleAttachToCard() {
      this.showAttachmentEditor = true;
    },
    handleAddAttachment() {
      this.edittingCardAttachments.push({
        link: null,
        title: "",
        type: null,
        status: "new",
      });
    },
    handleAttachmentEditting() {
      this.disableAttachmentEdit = true;
    },
    handleAttachmentEdittingEnd() {
      this.disableAttachmentEdit = false;
    },
    handleAttachmentCancelNew() {
      if (this.edittingCardAttachments.length > 0 && this.edittingCardAttachments[this.edittingCardAttachments.length - 1]) {
        this.edittingCardAttachments.pop();
      }
    },
    handleAttachmentRemove(attachment) {
      this.edittingCardAttachments = this.edittingCardAttachments.filter((a) => {
        return a.link !== attachment.link;
      });
    },
    handleVideoClick(type, url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
    },
    handleShowCardDetail(card, column, e) {
      this.edittingCard = card;
      this.edittingCardColumn = column;
      this.showCardEditor = false;
      this.showCardDetail = true;
    },
    handleCardDetailSave(updatedCard, event) {
      for (var i = 0; i < this.board.children.length; i++) {
        let column = this.board.children[i];
        for (var j = 0; j < column.children.length; j++) {
          if (column.children[j].id === this.edittingCard.id) {
            column.children[j] = Object.assign(this.edittingCard, updatedCard);
            this.showCardDetail = false;
            return;
          }
        }
      }

      this.showCardDetail = false;
    },
    handleAddDueDate() {
      this.showDueDateEditor = true;
    },
    handleDueDateSave(card) {
      this.showDueDateEditor = false;
      this.showCardEditor = false;
      this.edittingCard.dueDateSetting = Object.assign({}, card);
    },
    handleShowCardMembers() {
      this.showCardMembers = true;
    },
    handleCardMembersSave(selectedMemberIds, event) {
      this.edittingCard.selectedMemberIds = selectedMemberIds;
      this.showCardMembers = false;
      this.showCardEditor = false;
    },
    handleShowChecklist() {
      this.showChecklist = true;
    },
    handleChecklistSave(checklists, event) {
      this.edittingCard.checklists = checklists;
      this.showChecklist = false;
      this.showCardEditor = false;
    },
    getCardEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        // if ((" " + element.className + " ").indexOf(" card-scene ") > -1) {
        //   break;
        // }
        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.cardEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };

      this.attachmentEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    onColumnDrop(dropResult) {
      let board = Object.assign({}, this.board);
      board.children = applyDrag(board.children, dropResult);
      this.board = board;
    },
    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        let board = Object.assign({}, this.board);
        let column = board.children.filter((p) => p.id === columnId)[0];
        let columnIndex = board.children.indexOf(column);
        let newColumn = Object.assign({}, column);
        newColumn.children = applyDrag(newColumn.children, dropResult);
        board.children.splice(columnIndex, 1, newColumn);
        this.board = board;
      }
    },
    getCardPayload(columnId) {
      return (index) => {
        return this.board.children.filter((p) => p.id === columnId)[0].children[index];
      };
    },
    getGhostParent() {
      return document.body;
    },
    dragStart() {
      console.log("drag started");
    },
    log(...params) {
      console.log(...params);
    },
    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
  },
});
